import { Link } from "react-router-dom";
import { Map } from "lucide-react";

export default function DepartmentWideBanner({ count }) {
  return (
    <Link to="/bons-plans?coverage=department" data-testid="dept-wide-banner"
          className="block bg-slate-900 text-white rounded-2xl p-5 hover:bg-slate-800 transition-colors">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-amber-400/20 text-amber-300 grid place-items-center">
          <Map size={22}/>
        </div>
        <div className="flex-1">
          <div className="text-xs font-bold uppercase tracking-widest text-amber-300">Départemental</div>
          <div className="font-heading text-lg font-bold mt-0.5">Offres valables dans tout l'Eure-et-Loir</div>
          <div className="text-xs text-slate-300">Plombiers, alarmes, artisans mobiles et services qui interviennent partout dans le 28.</div>
        </div>
        <div className="hidden sm:block px-3 py-1.5 rounded-full bg-amber-400 text-slate-900 font-extrabold text-sm">{count} offres</div>
      </div>
    </Link>
  );
}
